import {connect} from 'react-redux';
import UserLogin from './UserLogin.jsx';
import {
  handleLoginClick,
  handleUserClick,
  handleLogoutClick,
  handlePartnerLoginClick
} from './actions';

const mapStateTopProps = state => {
  let username = state.shared.auth.displayName;
  
  if (username == null) username = ''; 
  return {
    groupName: state.shared.auth.groupName,
    username: username,
    isLoggedIn: !!state.shared.auth.email,
    isAllowed: state.shared.auth.isAllowed,
    roles: state.shared.auth.roles,
    permissions: state.shared.auth.permissions
  };
};

const mapDispatchToProps = dispatch => ({
  onLoginClick: () => dispatch(handleLoginClick()),
  onUserClick: () => dispatch(handleUserClick()),
  onLogoutClick: () => dispatch(handleLogoutClick()),
  onPartnerLoginClick: () => dispatch(handlePartnerLoginClick())
});

export default connect(mapStateTopProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/UserLoginContainer.jsx